import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import {
  NOTE_PREVIEW_BODY_FONT_SIZE_PX,
  NOTE_PREVIEW_LOGO_SIZE_PX,
  NOTE_PREVIEW_PRIMARY_COLOR,
  NOTE_PREVIEW_TEXT_COLOR,
} from "../note-preview-constant";
import { NotePreviewPracticeInfo } from "../note-preview-types";

export interface ReportPracticeHeaderProps {
  practice: NotePreviewPracticeInfo;
}

const iconStyle = {
  fontSize: 13,
  color: NOTE_PREVIEW_PRIMARY_COLOR,
  verticalAlign: "middle",
  marginRight: 2,
} as const;

const ReportPracticeHeader = ({ practice }: ReportPracticeHeaderProps) => (
  <header style={{ breakInside: "avoid" }}>
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: 16,
      }}
    >
      <div
        style={{
          width: NOTE_PREVIEW_LOGO_SIZE_PX,
          height: NOTE_PREVIEW_LOGO_SIZE_PX,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {practice.logo && (
          <img
            src={practice.logo}
            alt={practice.name}
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain",
            }}
          />
        )}
      </div>
      <div
        style={{
          borderLeft: `3px solid ${NOTE_PREVIEW_PRIMARY_COLOR}`,
          paddingLeft: 8,
          fontSize: NOTE_PREVIEW_BODY_FONT_SIZE_PX,
          color: NOTE_PREVIEW_TEXT_COLOR,
          lineHeight: 1.45,
          minWidth: 180,
        }}
      >
        <div style={{ fontSize: 17, fontWeight: 600, marginBottom: 2 }}>
          {practice.name}
        </div>
        {practice.addressLines.map((line, index) => (
          <div key={line} style={{ paddingLeft: index === 0 ? 0 : 15 }}>
            {index === 0 && <LocationOnIcon sx={iconStyle} />}
            {line}
          </div>
        ))}
        {practice.phone && (
          <div>
            <PhoneIphoneIcon sx={iconStyle} />
            {practice.phone}
          </div>
        )}
      </div>
    </div>
  </header>
);

export default ReportPracticeHeader;
